import React, { useEffect } from 'react';
import TaraLandingPage from '../../features/specialty/tara';

export default function TaraLandingRoute() {
  useEffect(() => {
    document.title = "TARA Prep 2026/2027 — Thinking & Aptitude Reasoning Assessment | Pathbuddy";
    window.scrollTo(0, 0);
  }, []);

  return <TaraLandingPage />;
}
